import React, { Component } from "react";
import $ from "jquery";
import * as Common from "../CommonControlls/CommonJs";
import MainLayout from "../CommonControlls/MainLayout";
import Topmenu from "../CommonControlls/Topmenubar";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import DropDown from "../CommonControlls/DropdownRendrer";
import AlertModal from "../CommonControlls/AlertModal";
import "react-datepicker/dist/react-datepicker.css";
import jsPDF from "jspdf";
import _ from "lodash";

const mapStateToProps = (store) => {
	return store;
};

const mapDispatchToProps = (dispatch) => {
	return {
		ShowAlert: (Settings) => {
			dispatch({ type: "UpdateAlert", payload: Settings });
		},
		ShowLoader: (Isloading) => {
			dispatch({ type: "UpdateLoader", payload: Isloading });
		},
	};
};

class HCFCluster_Add extends Component {
	constructor(props) {
		super(props);
		this.state = {
			Id: 0,
			isBatchLimit: false,
			TaskRepeatTypeVal: 1,
			SelectedRepeatDaysArr: [],
			ClusterTypelist: [
				{ id: 1, name: "BHU/GP Cluster" },
				{ id: 2, name: "RHC/PPM Cluster" },
			],
			ClusterTypeId: 1,
			RideType: "KM",
			Columns: [],
			rows: [],
			MatrixBlocks: [],
			InsertedMatrixList: [],
			IsValidated: false,

			alertModalData: {
				title: "",
				message: "",
				First_Callback: () => {},
				Second_Callback: () => {},
				type: 1,
			},

			ProvinceLoader: false,
			Provincelist: [],
			ProvinceId: 0,

			Subtype: 1,

			DistrictLoader: false,
			Districtlist: [],
			FilteredDistrictlist: [],
			DistrictId: 0,

			HCFLoader: false,
			BHUList: [],
			RHCList: [],
			BHUId: [],
			RHCId: 0,
			RHCIdNew: 0,

			RHCIds: [],

			SelectedGroup: "1",

			NonClusterdRHCLoader: false,
			NonClusterdRHCList: [],
			FilteredRHCListEdit: [],
			FilteredBHUListEdit: [],
			NonClusterdRHCId: 0,

			XpertSiteLoader: false,
			XpertSitelist: [],
			XpertSiteId: 0,

			RiderLoader: false,
			Riderlist: [],
			RiderId: [],
			TotalRiders: 15,

			ExtraFilteredDistrictlist: [],
			ExtraProvincelist: [],
			ExtraDistrictId: 0,
			ExtraProvinceId: 0,

			ExtraRiderList: [],
			ExtraRiderId: 0,

			AllFetchedBHU: [],
			AllFetchedRHC: [],
			AllFetchedNonClusterdRHC: [],
			AllFetchedXpertSite: [],
			AllFetchedRider: [],

			isDirectSubmit: false,

			permissions: [],

			SrList: [],
			SrId: 0,

			AllBHUList: [],
			AllRHCList: [],

			LastSavedisBatchLimit: null,
			LastSavedbatchlimit: 0,
			isValidatePossibility: true,

			possiblitySamplesCount: 0,
			possiblityassignmentCount: 0,

			FilteredRHCList: [],
			FilteredSrs: [],

			FilteredExpertSites: [],

			HCFTypelist: [
				{ id: 1, name: "BHU/GP" },
				{ id: 2, name: "RHC/PPM" },
			],
		};
	}

	HandleAutoSuggestValChange = (fieldId, value) => {
		this.setState({ [fieldId]: value }, () => {
			if (fieldId === "ExtraProvinceId") {
				const TempArr = this.state.Districtlist;

				const filteredArr = TempArr.filter(function (obj) {
					return obj.provinceId === value;
				});
				this.setState({
					ExtraFilteredDistrictlist: filteredArr,
				});
			}
			if (fieldId === "ProvinceId") {
				var TempArr = this.state.Districtlist;
				const tempSrs = this.state.SrList;
				const filteredSrs = tempSrs.filter((item) => item.provinceid === value);

				var filteredArr = TempArr.filter(function (obj) {
					return obj.provinceId === value;
				});
				this.setState({
					// FilteredDistrictlist: filteredArr.sort(Common.compare),
					ExtraFilteredDistrictlist: filteredArr,
					FilteredSrs: filteredSrs,
				});
			}
			if (fieldId === "SrId") {
				const tempDistricts = this.state.Districtlist;
				var filteredSelectedDistricts = tempDistricts.filter(
					(obj) => obj.subrecipientid === value
				);
				this.setState({
					FilteredDistrictlist: filteredSelectedDistricts,
				});
			}
			if (fieldId === "HCFTypeId") {
				this.setState({
					Subtype: value,
					HCFTypeId: value,
				});
			}
			if (fieldId === "DistrictId") {
				const tempBHU = this.state.BHUList;
				const tempRHC = this.state.RHCList;
				const tempXpert = this.state.XpertSitelist;
				const tempRiders = this.state.AllFetchedRider;
				const filteredBHU = tempBHU.filter((item) => item.districtId === value);
				const filteredRHC = tempRHC.filter((item) => item.districtId === value);
				const filteredXpert = tempXpert.filter(
					(item) => item.districtId === value
				);
				const filteredRiders = tempRiders.filter(
					(item) => item.districtId === value
				);
				this.setState({
					ExtraRiderId: value,
					DistrictId: value,
					FilteredBHUList: filteredBHU,
					FilteredRHCList: filteredRHC,

					FilteredExpertSites: filteredXpert,
					FilteredRiders: filteredRiders,
				});
				console.log("filteredRHC========", this.state.FilteredRHCList);
				if (this.state.Id === 0) {
					this.SelectRiders();
				}
				// this.FilterDistrictDependant(value, () => {})
			}
			if (fieldId === "ExtraRiderId") {
				this.FilterDistrictDependant(value, () => {});
			}
			if (fieldId === "ExtraDistrictId") {
				Common.Ajax(
					this.props.UserAuthentication.AuthToken,
					"GET",
					false,
					Common.APILinks.GetRiders,
					{
						provinceId: this.state.ExtraProvinceId,
						districtId: value,
					},
					(resp) => {
						if (resp.status) {
							this.setState({
								ExtraRiderList: resp.data,
							});
						}
					}
				);
				this.setState({
					ExtraDistrictId: value,
				});
			}
		});
	};
	FilterDistrictDependant = (Selecteddistrict, Callback) => {
		// Filter BHU
		// var TempAllFetchedBHU = this.state.AllFetchedBHU
		// var filteredBHUList = TempAllFetchedBHU.filter(function (obj) {
		//     return (obj.districtId === Selecteddistrict)
		// });
		// var selectedBHU = this.state.BHUId
		// var filteredBHUIdArr = Common.ConvertToCommaSplitArray(filteredBHUList, "id")
		// var filteredSelectedBHU = selectedBHU.filter(function (obj) {
		//     return filteredBHUIdArr.indexOf(obj.id) > -1
		// });

		const tempBHU = this.state.BHUList;
		const tempRHC = this.state.RHCList;
		const filteredBHU = tempBHU.filter(
			(item) => item.districtId === Selecteddistrict
		);
		// const filteredRHC = tempRHC.filter(item => item.districtId === Selecteddistrict)
		const filteredRHC = _.filter(
			tempRHC,
			(t) => t.districtId === Selecteddistrict
		);

		// Filter RHC
		// var TempAllFetchedRHC = this.state.AllFetchedRHC
		// var filteredRHCList = TempAllFetchedRHC.filter(function (obj) {
		//     return (obj.districtId === Selecteddistrict)
		// });
		// var selectedRHC = this.state.RHCId
		// var filteredRHCIdArr = Common.ConvertToCommaSplitArray(filteredRHCList, "id")
		// var filteredSelectedRHC = selectedRHC.filter(function (obj) {
		//     return filteredRHCIdArr.indexOf(obj.id) > -1
		// });

		// Filter Non Clustered RHC=
		var TempAllFetchedNonClusterdRHC = this.state.AllFetchedNonClusterdRHC;
		var filteredNonClusterdRHCList = TempAllFetchedNonClusterdRHC.filter(
			function (obj) {
				return obj.districtId === Selecteddistrict;
			}
		);
		var filteredNonClusterdRHCIdArr = Common.ConvertToCommaSplitArray(
			filteredNonClusterdRHCList,
			"id"
		);
		var filteredSelectedNonClusterdRHC = this.state.NonClusterdRHCId;
		if (
			filteredNonClusterdRHCIdArr.indexOf(filteredSelectedNonClusterdRHC) === -1
		) {
			filteredSelectedNonClusterdRHC = 0;
		}

		// Filter xpert site
		var TempAllFetchedXpertSite = this.state.AllFetchedXpertSite;
		var filteredXpertSiteList = TempAllFetchedXpertSite.filter(function (obj) {
			return obj.districtId === Selecteddistrict;
		});
		var filteredXpertSiteIdArr = Common.ConvertToCommaSplitArray(
			filteredXpertSiteList,
			"id"
		);
		var filteredSelectedXpertSite = this.state.XpertSiteId;
		if (filteredXpertSiteIdArr.indexOf(filteredSelectedXpertSite) === -1) {
			filteredSelectedXpertSite = 0;
		}

		// Filter Riders
		var TempAllFetchedRider = this.state.AllFetchedRider;
		var filteredRiderList = TempAllFetchedRider.filter(function (obj) {
			return obj.districtId === Selecteddistrict;
		});
		// var selectedRiders = this.state.RiderId
		// var filteredRiderIdArr = Common.ConvertToCommaSplitArray(filteredRiderList, "id")
		// var filteredSelectedRider = selectedRiders.filter(function (obj) {
		//     return filteredRiderIdArr.indexOf(obj.id) > -1
		// });
		console.log({ filteredRHC });
		console.log("::::::::=========filteredBHU:::::::::", filteredBHU);

		this.setState(
			{
				// BHUList: filteredBHUList,
				// BHUId: filteredSelectedBHU,
				// FilteredRHC: filteredRHCList,
				// RHCId: filteredSelectedRHC,
				NonClusterdRHCList: filteredNonClusterdRHCList,
				NonClusterdRHCId: filteredSelectedNonClusterdRHC,
				// XpertSitelist: filteredXpertSiteList,
				FilteredRHCListEdit: filteredRHC,
				FilteredBHUListEdit: filteredBHU,

				// XpertSiteId: filteredSelectedXpertSite,
				Riderlist: filteredRiderList,
				// RiderId: filteredSelectedRider,
			},
			() => {
				Callback();
			}
		);
	};
	selectRepeatDays = (day) => {
		var temparr = this.state.SelectedRepeatDaysArr;
		if (temparr.length === 0) {
			temparr.push(day);
			$("#" + day + "-Div").addClass("RepeatDays-Div-Selected");
		} else {
			var i = temparr.length - 1;
			var checkKey = 1;
			for (var j = 0; j <= i; j++) {
				if (temparr[j] === day) {
					checkKey = 2;
				}
			}
			if (checkKey === 1) {
				temparr.push(day);
				$("#" + day + "-Div").addClass("RepeatDays-Div-Selected");
			} else {
				$("#" + day + "-Div").removeClass("RepeatDays-Div-Selected");
				temparr.splice(temparr.indexOf(day), 1);
			}
		}
		this.setState({
			SelectedRepeatDaysArr: temparr,
		});
	};

	render() {
		return (
			<div>
				<AlertModal {...this.state.alertModalData} />
				<MainLayout />
				<div id="right-panel" className="right-panel">
					<Topmenu
						PageTitle={this.state.Id === 0 ? "Add Cluster" : "Edit Cluster"}
						isShowAddBtn={false}
					/>
					<div class="content">
						<button
							type="button"
							id="show_AssignmentPossibilityModel"
							style={{ display: "none" }}
							className="Primary mg-b-10"
							data-toggle="modal"
							data-target="#AssignmentPossibilityModel"
						>
							Primary
						</button>
						<div
							id="AssignmentPossibilityModel"
							className="modal fade"
							tabIndex="-1"
							role="dialog"
							aria-labelledby="addappTitle"
							aria-hidden="true"
						>
							<div
								className="modal-dialog modal-dialog-centered"
								role="document"
							>
								<div className="modal-content">
									<div className="modal-header">
										<div className="ModalTopClose_btn">
											<span
												style={{ cursor: "pointer" }}
												id="CloseAssignmentPossibilityModel"
												data-dismiss="modal"
												aria-hidden="true"
											>
												x
											</span>
										</div>
										<h5
											className="modal-title"
											style={{ fontSize: "17px", fontWeight: "700" }}
										>
											Information
										</h5>
									</div>

									<div className="modal-body">
										<div
											className=""
											style={{ padding: "0px 15px", fontSize: "16px" }}
										>
											<div className="col-md-12">
												{this.state.possiblityassignmentCount} job(s) of{" "}
												{this.state.possiblitySamplesCount} sample(s) will be be
												generated due to batch limit changes, do you want to
												proceed?
											</div>
										</div>

										<div
											style={{
												float: "right",
												marginRight: "15px",
												marginTop: "35px",
											}}
										>
											<button
												type="button"
												onClick={() => {
													this.setState(
														{ isValidatePossibility: false },
														() => {
															$("#CloseAssignmentPossibilityModel").click();
															this.SubmitForm();
														}
													);
												}}
												className="btn btn_style1"
											>
												Yes
											</button>
											<button
												type="button"
												data-dismiss="modal"
												className="btn btn_style2"
											>
												No
											</button>
										</div>
									</div>
								</div>
							</div>
						</div>

						<form onSubmit={this.validateformpre} noValidate>
							<div className="card" hidden={this.state.IsValidated}>
								<div className="card-body row">
									<div className="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12">
										<label htmlFor="">
											<span style={{ color: "red" }}>* </span>Cluster Name
										</label>
										<input
											autoComplete="off"
											type="text"
											className="form-control"
											id="ClusterName"
											placeholder="Enter cluster name"
										/>
									</div>
									<div className="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
									<div className="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>

									<div className="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12">
										<label htmlFor="">
											<span style={{ color: "red" }}>* </span>Province
										</label>
										<DropDown
											multi={false}
											dropdownRenderer={false}
											create={false}
											onChange={this.HandleAutoSuggestValChange}
											Type="ProvinceId"
											options={this.state.Provincelist}
											val={this.state.ProvinceId}
											addPlaceholder=""
											disabled={false}
											loading={this.state.ProvinceLoader}
											searchBy="name"
											labelField="name"
											valueField="id"
											contentRenderer={false}
											placeholder="Select"
										/>
									</div>

									<div className="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12">
										<label htmlFor="">
											<span style={{ color: "red" }}>* </span>SR Name
										</label>
										<DropDown
											multi={false}
											create={false}
											onChange={this.HandleAutoSuggestValChange}
											Type="SrId"
											options={this.state.FilteredSrs}
											val={this.state.SrId}
											addPlaceholder=""
											disabled={false}
											searchBy="name"
											labelField="name"
											valueField="id"
											contentRenderer={false}
											placeholder="Select"
										/>
									</div>

									<div className="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12">
										<label htmlFor="">
											<span style={{ color: "red" }}>* </span>District
										</label>
										<DropDown
											multi={false}
											dropdownRenderer={false}
											create={false}
											onChange={this.HandleAutoSuggestValChange}
											Type="DistrictId"
											options={this.state.FilteredDistrictlist}
											val={this.state.DistrictId}
											addPlaceholder=""
											disabled={false}
											loading={this.state.DistrictLoader}
											searchBy="name"
											labelField="name"
											valueField="id"
											contentRenderer={false}
											placeholder="Select"
										/>
									</div>

									<div className="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12">
										<label htmlFor="">
											<span style={{ color: "red" }}>* </span>Riders
										</label>
										<DropDown
											multi={true}
											dropdownRenderer={true}
											create={false}
											onChange={this.HandleAutoSuggestValChange}
											Type="RiderId"
											options={this.state.AllFetchedRider}
											val={this.state.RiderId}
											addPlaceholder=""
											disabled={false}
											loading={this.state.RiderLoader}
											searchBy="name"
											labelField="name"
											valueField="id"
											contentRenderer={true}
											placeholder="Select"
										/>
									</div>

									<div className="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12">
										<label htmlFor="">
											<span style={{ color: "red" }}>* </span>Cut Off Time
										</label>
										<input
											autoComplete="off"
											type="time"
											className="form-control"
											onChange={(event) => console.log(event.target.value)}
											id="CutOffTime"
										/>
									</div>

									<div className="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12">
										<label>Select Ride Type</label>
										<select
											className="form-control"
											value={this.state.RideType}
											onChange={(event) =>
												this.setState({ RideType: event.target.value })
											}
										>
											<option value="KM">KM</option>
											<option value="Sample">Sample</option>
										</select>
									</div>

									<div className="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
										<label htmlFor="">
											<span style={{ color: "red" }}>* </span>Type
										</label>
										<DropDown
											multi={false}
											dropdownRenderer={false}
											create={false}
											onChange={this.HandleAutoSuggestValChange}
											Type="HCFTypeId"
											options={this.state.HCFTypelist}
											val={this.state.HCFTypeId}
											addPlaceholder=""
											disabled={this.state.Id !== 0}
											loading={false}
											searchBy="name"
											labelField="name"
											valueField="id"
											contentRenderer={false}
											placeholder="Select"
											clearable={false}
										/>
									</div>

									{this.state.HCFTypeId !== 1 && (
										<div
											className="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12"
											hidden={
												!(
													this.state.HCFTypeId === 2 ||
													this.state.SelectedGroup === "1"
												)
											}
										>
											<label htmlFor="">
												<span style={{ color: "red" }}>* </span>RHC
											</label>
											<DropDown
												multi={true}
												dropdownRenderer={true}
												create={false}
												onChange={this.HandleAutoSuggestValChange}
												Type="RHCIds"
												options={
													this.state.Id === 0
														? this.state.FilteredRHCList
														: this.state.FilteredRHCListEdit
												}
												val={this.state.RHCIds}
												addPlaceholder=""
												disabled={false}
												loading={this.state.HCFLoader}
												searchBy="name"
												labelField="name"
												valueField="id"
												contentRenderer={true}
												placeholder="Select"
											/>
										</div>
									)}

									{this.state.HCFTypeId === 2 && (
										<div className="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12">
											<label htmlFor="">
												<span style={{ color: "red" }}>* </span>Xpert Site
											</label>

											<DropDown
												// ValueType={true}
												multi={false}
												dropdownRenderer={false}
												create={false}
												onChange={this.HandleAutoSuggestValChange}
												Type="XpertSiteId"
												options={this.state.FilteredExpertSites}
												val={this.state.XpertSiteId}
												addPlaceholder=""
												disabled={false}
												loading={this.state.XpertSiteLoader}
												searchBy="name"
												labelField="name"
												valueField="id"
												contentRenderer={false}
												placeholder="Select"
											/>
										</div>
									)}

									{this.state.HCFTypeId === 1 && (
										<div className="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12">
											<label htmlFor="">Select Cluster Type</label>
											<select
												value={
													this.state.Subtype === 3 ? "2" : this.state.Subtype
												}
												onChange={(event) => {
													this.setState({
														Subtype:
															+event.target.value === 2
																? 3
																: +event.target.value,
													});
												}}
												className="form-control"
											>
												<option value="1">BHU/GP to RHC/PPM</option>
												<option value="2">BHU/GP to Xpert Sites</option>
											</select>
										</div>
									)}

									<div
										className="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12"
										hidden={this.state.HCFTypeId !== 1}
									>
										<label htmlFor="">
											<span style={{ color: "red" }}>* </span>BHU
										</label>
										<DropDown
											multi={true}
											dropdownRenderer={true}
											create={false}
											onChange={this.HandleAutoSuggestValChange}
											Type="BHUId"
											options={
												this.state.Id === 0
													? this.state.FilteredBHUList
													: this.state.FilteredBHUListEdit
											}
											val={this.state.BHUId}
											addPlaceholder=""
											disabled={false}
											loading={this.state.HCFLoader}
											searchBy="name"
											labelField="name"
											valueField="id"
											contentRenderer={true}
											placeholder="Select"
										/>
									</div>

									{this.state.Subtype === 1 && (
										<div className="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12">
											<label htmlFor="">
												<span style={{ color: "red" }}>* </span>RHC new
											</label>
											<DropDown
												ValueType={true}
												multi={false}
												dropdownRenderer={false}
												create={false}
												onChange={this.HandleAutoSuggestValChange}
												Type="RHCId"
												options={this.state.FilteredRHCList}
												val={this.state.RHCId}
												addPlaceholder=""
												disabled={false}
												loading={this.state.HCFLoader}
												searchBy="name"
												labelField="name"
												valueField="id"
												contentRenderer={false}
												placeholder="Select"
											/>
										</div>
									)}

									{/*<div className="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12"*/}
									{/*     hidden={!(this.state.HCFTypeId === 2 || this.state.SelectedGroup === '1')}>*/}
									{/*    <label htmlFor=""><span style={{color: "red"}}>* </span>RHC</label>*/}
									{/*    <DropDown*/}
									{/*        ValueType={true}*/}
									{/*        multi={false}*/}
									{/*        dropdownRenderer={false}*/}
									{/*        create={false}*/}
									{/*        onChange={this.HandleAutoSuggestValChange}*/}
									{/*        Type="NonClusterdRHCId"*/}
									{/*        options={this.state.NonClusterdRHCList}*/}
									{/*        val={this.state.NonClusterdRHCId}*/}
									{/*        addPlaceholder=""*/}
									{/*        disabled={false}*/}
									{/*        loading={this.state.NonClusterdRHCLoader}*/}
									{/*        searchBy="name"*/}
									{/*        labelField="name"*/}
									{/*        valueField="id"*/}
									{/*        contentRenderer={false}*/}
									{/*        placeholder="Select"*/}
									{/*    />*/}
									{/*</div>*/}

									<div
										className="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12"
										hidden={
											this.state.HCFTypeId !== 1 || this.state.Subtype !== 3
										}
									>
										<label htmlFor="">
											<span style={{ color: "red" }}>* </span>Xpert Site
										</label>
										<DropDown
											ValueType={true}
											multi={false}
											dropdownRenderer={false}
											create={false}
											onChange={this.HandleAutoSuggestValChange}
											Type="XpertSiteId"
											options={this.state.FilteredExpertSites}
											val={this.state.XpertSiteId}
											addPlaceholder=""
											disabled={false}
											loading={this.state.XpertSiteLoader}
											searchBy="name"
											labelField="name"
											valueField="id"
											contentRenderer={false}
											placeholder="Select"
										/>
									</div>

									

									<div className="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12">
										<label
											className="checkboxesinputs"
											style={{ bottom: "0", top: "2", marginTop: "10px" }}
										>
											<input
												className="NodeCheckbox_input"
												type="checkbox"
												checked={this.state.isBatchLimit}
												onChange={(e) => {
													this.setState({ isBatchLimit: e.target.checked });
												}}
											/>
											<span className="checkmark"></span>
											<span
												style={{
													fontWeight: "100",
													color: "black",
												}}
											>
												Enable sample batch limit
											</span>
										</label>
									</div>

									<div
										className="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12"
										hidden={!this.state.isBatchLimit}
									>
										<label htmlFor="">
											<span style={{ color: "red" }}>* </span>Batch limit
										</label>
										<input
											autoComplete="off"
											type="number"
											className="form-control"
											id="batchlimit"
											placeholder="Enter sample batch limit"
										/>
									</div>

									<div className="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12 row">
										<div
											className="col-lg-12 col-md-12 col-sm-12 col-xs-12"
											style={{ padding: "0px" }}
										>
											<label htmlFor="">
												<span style={{ color: "red" }}>* </span>Frequency of
												visits
											</label>
											<div
												className="col-md-12 col-lg-12 row"
												style={{ marginTop: "15px" }}
											>
												<label className="Radio_container">
													Every Day
													<input
														type="radio"
														name="TaskRepeatType"
														checked={this.state.TaskRepeatTypeVal === 1}
														onClick={() => {
															this.setState({ TaskRepeatTypeVal: 1 });
														}}
													/>
													<span className="Radio_checkmark"></span>
												</label>
												<label className="Radio_container">
													Every Week
													<input
														type="radio"
														name="TaskRepeatType"
														checked={this.state.TaskRepeatTypeVal === 2}
														onClick={() => {
															this.setState({ TaskRepeatTypeVal: 2 });
														}}
													/>
													<span className="Radio_checkmark"></span>
												</label>
												<label className="Radio_container">
													Every Few Working Days
													<input
														type="radio"
														name="TaskRepeatType"
														checked={this.state.TaskRepeatTypeVal === 3}
														onClick={() => {
															this.setState({ TaskRepeatTypeVal: 3 });
														}}
													/>
													<span className="Radio_checkmark"></span>
												</label>
											</div>
										</div>

										<div
											className="col-lg-8 col-md-8 col-sm-12 col-xs-12"
											style={{ padding: "0px" }}
											hidden={this.state.TaskRepeatTypeVal !== 2}
										>
											<label htmlFor="">
												<span style={{ color: "red" }}>* </span>Week days
											</label>
											<div className="col-md-12 col-lg-12 row">
												<div
													id="Sunday-Div"
													className="RepeatDays-Div"
													onClick={(e) => this.selectRepeatDays("Sunday")}
												>
													Sun
												</div>
												<div
													id="Monday-Div"
													className="RepeatDays-Div"
													onClick={(e) => this.selectRepeatDays("Monday")}
												>
													Mon
												</div>
												<div
													id="Tuesday-Div"
													className="RepeatDays-Div"
													onClick={(e) => this.selectRepeatDays("Tuesday")}
												>
													Tue
												</div>
												<div
													id="Wednesday-Div"
													className="RepeatDays-Div"
													onClick={(e) => this.selectRepeatDays("Wednesday")}
												>
													Wed
												</div>
												<div
													id="Thursday-Div"
													className="RepeatDays-Div"
													onClick={(e) => this.selectRepeatDays("Thursday")}
												>
													Thu
												</div>
												<div
													id="Friday-Div"
													className="RepeatDays-Div"
													onClick={(e) => this.selectRepeatDays("Friday")}
												>
													Fri
												</div>
												<div
													id="Saturday-Div"
													className="RepeatDays-Div"
													onClick={(e) => this.selectRepeatDays("Saturday")}
												>
													Sat
												</div>
											</div>
										</div>

										<div
											className="col-lg-4 col-md-4 col-sm-12 col-xs-12"
											style={{ padding: "0px" }}
											hidden={this.state.TaskRepeatTypeVal !== 3}
										>
											<label htmlFor="">
												<span style={{ color: "red" }}>* </span>Specify number
												of days
											</label>
											<input
												autoComplete="off"
												type="number"
												className="form-control"
												id="everyNoOfDays"
												placeholder="Enter number of days"
											/>
										</div>
									</div>

									<div
										className="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12 row"
										style={{ justifyContent: "center" }}
									>
										<button
											type="button"
											onClick={this.validateformpre}
											id="CreateMatrixbtn"
											className="btn"
										>
											Distance Matrix
											<i
												style={{ marginLeft: "7px" }}
												className="fa fa-long-arrow-right"
												aria-hidden="true"
											></i>
										</button>
									</div>

									<div className="form_footer formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
										<button
											type="button"
											id=""
											onClick={this.UpdateFromWithoutMatrix}
											hidden={this.state.Id === 0}
											className="btn btn_style1"
										>
											Save
										</button>

										{this.state.permissions.includes(
											"bhusrhcscluster-delete"
										) && (
											<button
												type="button"
												id=""
												onClick={this.onDelete}
												hidden={this.state.Id === 0}
												className="btn btn_style2"
											>
												Delete
											</button>
										)}

										<Link to="/BHUAndRHCClusters">
											<button type="button" id="" className="btn btn_style3">
												Cancel
											</button>
										</Link>
									</div>
								</div>
							</div>

							<div className="card" hidden={!this.state.IsValidated}>
								<div className="card-body row">
									<span onClick={this.ExportPdf} className="TableExport_button">
										Export Pdf
									</span>

									<div
										className="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12"
										style={{ display: "flex" }}
									>
										<div
											className="TableY_AxisTitle"
											style={{ flex: "1", maxWidth: "30px" }}
										>
											Pickup's
										</div>
										<div className="Matrix_view">
											<div className="Matrix_wrapper">
												<div className="" style={{ textAlign: "center" }}>
													Destinations
												</div>
												<table id="tableData" className="MatrixTable">
													<thead>
														<tr>
															<th className="sticky-col first-col"></th>
															{this.state.Columns.map((item, index) => {
																return (
																	<th className="second-col">
																		{item.label}
																		<div className="TableHeader_SubTitle">
																			{item.type}
																		</div>
																	</th>
																);
															})}
														</tr>
													</thead>

													<tbody>
														{this.state.MatrixBlocks.map((item, index) => {
															return (
																<tr>
																	<th className="sticky-col first-col">
																		{item.pickupLable}
																	</th>
																	{item.list.map((listitem, listindex) => {
																		return (
																			<th style={{ textAlign: "center" }}>
																				{listitem.isEdit ? (
																					<>
																						<input
																							autoComplete="off"
																							id={
																								index +
																								"_" +
																								listindex +
																								"_MatrixInput"
																							}
																							onChange={() => {
																								this.handleDistancechange(
																									index,
																									listindex
																								);
																							}}
																							type="number"
																							className="form-control Search_InputField center_AlignText"
																							placeholder="Distance in KM"
																							defaultValue={listitem.distance}
																						/>
																						-
																						<input
																							autoComplete="off"
																							id={
																								index +
																								"_" +
																								listindex +
																								"_MatrixInputVerified"
																							}
																							onChange={() => {
																								this.handleDistancechange(
																									index,
																									listindex
																								);
																							}}
																							type="number"
																							className="form-control Search_InputField center_AlignText"
																							placeholder="Verified Distance in KM"
																							defaultValue={listitem.verifiedDistance}
																						/>
																					</>
																				) : (
																					listitem.distance
																				)}
																				<span hidden={true}>
																					{listitem.distance}
																				</span>
																			</th>
																		);
																	})}
																</tr>
															);
														})}
													</tbody>
												</table>
											</div>
										</div>
									</div>

									<div
										className="formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12 row"
										style={{ justifyContent: "center" }}
									>
										<button
											type="button"
											onClick={() => {
												this.setState({ IsValidated: false });
											}}
											id=""
											className="btn"
										>
											<i
												style={{ marginRight: "7px" }}
												className="fa fa-long-arrow-left"
												aria-hidden="true"
											></i>
											Cluster Details
										</button>
									</div>

									<div className="form_footer formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
										<button
											type="button"
											id="Form_SaveBtn"
											onClick={this.SubmitForm}
											className="btn btn_style1"
										>
											Save
										</button>

										{this.state.permissions.includes(
											"bhusrhcscluster-delete"
										) && (
											<button
												type="button"
												id="Form_DeleteBtn"
												onClick={this.onDelete}
												hidden={this.state.Id === 0}
												className="btn btn_style2"
											>
												Delete
											</button>
										)}

										<Link to="/BHUAndRHCClusters">
											<button
												type="button"
												id="Form_CancelBtn"
												className="btn btn_style3"
											>
												Cancel
											</button>
										</Link>

										{/* Hide button for reset */}
										<Link
											style={{ display: "none" }}
											to="/BHUAndRHCClusters_Add"
										>
											<button
												id="Form_ResetBtn"
												type="button"
												className="btn initial-btn Cancel-Form-btn Form_Btn"
											>
												Reset
											</button>
										</Link>
									</div>
								</div>
							</div>
						</form>

						{this.state.Id !== 0 && (
							<form onSubmit={this.AddExtraRider}>
								<div className="card">
									<div className="card-header">Add Extra Rider</div>
									<div className=" card-body row">
										<div className="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12">
											<label htmlFor="">
												<span style={{ color: "red" }}>* </span>Province
											</label>
											<DropDown
												multi={false}
												dropdownRenderer={false}
												create={false}
												onChange={this.HandleAutoSuggestValChange}
												Type="ExtraProvinceId"
												options={this.state.ExtraProvincelist}
												val={this.state.ExtraProvinceId}
												addPlaceholder=""
												disabled={false}
												loading={this.state.ProvinceLoader}
												searchBy="name"
												labelField="name"
												valueField="id"
												contentRenderer={false}
												placeholder="Select"
											/>
										</div>

										<div className="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12">
											<label htmlFor="">
												<span style={{ color: "red" }}>* </span>District
											</label>
											<DropDown
												multi={false}
												dropdownRenderer={false}
												create={false}
												onChange={this.HandleAutoSuggestValChange}
												Type="ExtraDistrictId"
												options={this.state.ExtraFilteredDistrictlist}
												val={this.state.ExtraDistrictId}
												addPlaceholder=""
												disabled={false}
												loading={this.state.DistrictLoader}
												searchBy="name"
												labelField="name"
												valueField="id"
												contentRenderer={false}
												placeholder="Select"
											/>
										</div>

										<div className="formInput_Container col-lg-4 col-md-4 col-sm-12 col-xs-12">
											<label htmlFor="">
												<span style={{ color: "red" }}>* </span>Riders
											</label>
											<DropDown
												multi={false}
												dropdownRenderer={false}
												create={false}
												onChange={this.HandleAutoSuggestValChange}
												Type="ExtraRiderId"
												options={this.state.ExtraRiderList}
												val={this.state.ExtraRiderId}
												addPlaceholder=""
												disabled={false}
												// loading={this.state.DistrictLoader}
												searchBy="name"
												labelField="name"
												valueField="id"
												contentRenderer={false}
												placeholder="Select"
											/>
										</div>
										<div className="form_footer formInput_Container col-lg-12 col-md-12 col-sm-12 col-xs-12">
											<button
												type="submit"
												id="Form_SaveBtn"
												className="btn btn_style1"
											>
												Save
											</button>
										</div>
									</div>
								</div>
							</form>
						)}
					</div>
				</div>
			</div>
		);
	}

	UpdateFromWithoutMatrix = () => {
		this.setState(
			{
				isDirectSubmit: true,
			},
			() => {
				this.ValidateForm();
			}
		);
	};
	validateformpre = () => {
		this.setState(
			{
				isDirectSubmit: false,
			},
			() => {
				this.ValidateForm();
			}
		);
	};

	componentWillMount() {
		if (this.props.UserAuthentication.AuthToken === "") {
			this.props.history.push("/Login");
		}
	}

	componentDidMount() {
		Common.AddClassToMenueLink("MenuLink_HCFClusters");

		var Id = Common.GetId();
		this.setState(
			{
				Id,
			},
			() => {
				this.GetPageConfigData(() => {
					if (Id !== 0) {
						this.selectHCFClusterDetails(Id);
					}
				});
			}
		);
		this.SelectSubReciepents();
		// this.SelectRiders()
		// state id = 0 // in add mode
		console.log("state id  = ", this.state.Id);

		//if(this.state.Id === 1){
		this.SelectRHCEdit();
		this.SelectBHUEdit();
		//}

		//this.SelectFacilityTypes()

		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.APILinks.SelectAll_RolesPermissions,
			{
				pageSize: 15,
				pageNumber: 1,
			},
			(resp) => {
				const modifiedPermissions = resp.data
					.filter(
						(p) =>
							p.permissioN_GROUP === "BHUsRHCsCluster" && p.permissioN_ALLOWED
					)
					.map((d) => d.permissioN_NAME);
				this.setState({ permissions: modifiedPermissions });
			}
		);
	}

	GetPageConfigData = (CallBack) => {
		this.props.ShowLoader({ Isloading: true });
		var d1 = $.Deferred();
		var d2 = $.Deferred();
		var d3 = $.Deferred();
		var d4 = $.Deferred();
		var d5 = $.Deferred();
		this.SelectProvinces(() => {
			d1.resolve();
		});
		this.SelectDistricts(() => {
			d2.resolve();
		});
		this.SelectHCF(() => {
			d3.resolve();
		});
		this.SelectRHC(() => {
			d4.resolve();
		});
		this.SelectXpertSites(() => {
			d5.resolve();
		});

		$.when(d1, d2, d3, d4, d5).done(() => {
			this.props.ShowLoader({ Isloading: false });
			CallBack();
		});
	};
	ExportPdf = () => {
		const doc = new jsPDF();

		doc.autoTable({ html: "#tableData" });

		doc.save("name.pdf");
	};
	SelectFacilityTypes = () => {
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.BaseUrlAPI + "/api/HCF/SelectFacilityType",
			{},
			(data) => {
				this.setState({
					HCFTypelist: data.data,
				});
			},
			(error) => {
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};
	AddExtraRider = (event) => {
		event.preventDefault();
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"POST",
			false,
			Common.BaseUrlAPI +
				`/api/Rider/UpdateHCFClusterRider?riderId=${this.state.ExtraRiderId}&hcfclusterId=${this.state.Id}`,
			{},
			(resp) => {
				this.setState({ ProvinceLoader: false });
				this.props.ShowAlert({ Type: 1, Msg: "Rider added successfully" });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};
	SelectSubReciepents = () => {
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectALl_SubRecipient,
			{},
			(resp) => {
				if (resp.status) {
					this.setState({
						SrList: resp.data.map((d) => ({
							id: d.id,
							name: d.short_name,
							districtId: d.districtid,
							...d,
						})),
					});
				}
			}
		);
	};
	SelectProvinces = (Callback) => {
		this.setState({ ProvinceLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectAll_Province,
			{},
			(data) => {
				this.setState({
					ProvinceLoader: false,
					Provincelist: data.data,
					ExtraProvincelist: data.data,
				});
				Callback();
			},
			(error) => {
				this.setState({ ProvinceLoader: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				Callback();
			}
		);
	};
	SelectDistricts = (Callback) => {
		this.setState({ DistrictLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.SelectAll_District,
			{},
			(data) => {
				this.setState({
					DistrictLoader: false,
					Districtlist: data.data,
					ExtraDistrictlist: data.data,
				});
				Callback();
			},
			(error) => {
				this.setState({ DistrictLoader: false });
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				Callback();
			}
		);
	};

	SelectHCF = (Callback) => {
		this.setState({ HCFLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.BaseUrlAPI + "/api/HCF/SelectNonClusteredEdit", //Common.APILinks.SelectNonClustered_HCF,
			{ clusterId: this.state.Id },
			(Result) => {
				debugger;
				if (Result.status) {
					var BHUList = [];
					var RHCList = [];
					for (var i = 0; i < Result.data.length; i++) {
						if (Result.data[i].typeId === 1) {
							BHUList.push(Result.data[i]);
						}

						// else {
						//   RHCList.push(Result.data[i])
						// }
					}
					this.setState({
						BHUList: BHUList,
						// RHCList: RHCList,
						AllFetchedBHU: BHUList,
						//AllFetchedRHC: RHCList,
						HCFLoader: false,
					});
				} else {
					this.setState({
						HCFLoader: false,
					});
					this.props.ShowAlert({ Type: 0, Msg: Result.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
				Callback();
			},
			(error) => {
				this.setState({
					HCFLoader: false,
				});
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				Callback();
			}
		);
	};
	SelectRHC = (Callback) => {
		this.setState({ NonClusterdRHCLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.APILinks.SelectNonClustered_RHC,
			{ clusterId: this.state.Id },
			(Result) => {
				if (Result.status) {
					this.setState({
						AllFetchedNonClusterdRHC: Result.data,
						NonClusterdRHCList: Result.data,
						RHCList: Result.data,
						NonClusterdRHCLoader: false,
					});
				} else {
					this.setState({
						NonClusterdRHCLoader: false,
					});
					this.props.ShowAlert({ Type: 0, Msg: Result.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
				Callback();
			},
			(error) => {
				this.setState({
					NonClusterdRHCLoader: false,
				});
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				Callback();
			}
		);
	};
	SelectXpertSites = (Callback) => {
		this.setState({ XpertSiteLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.APILinks.SelectAll_XpertSites,
			{},
			(Result) => {
				if (Result.status) {
					this.setState({
						XpertSitelist: Result.data,
						AllFetchedXpertSite: Result.data,
						XpertSiteLoader: false,
					});
				} else {
					this.setState({
						XpertSiteLoader: false,
					});
					this.props.ShowAlert({ Type: 0, Msg: Result.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
				Callback();
			},
			(error) => {
				this.setState({
					XpertSiteLoader: false,
				});
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				Callback();
			}
		);
	};
	SelectRiders = () => {
		this.setState({ RiderLoader: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"GET",
			false,
			Common.APILinks.Select_RiderProfiles_withouDetails,
			{
				sortField: "id",
				sortOrder: "ase",
				pageNumber: 1,
				pageSize: 100,
				provinceId: this.state.ProvinceId,
				districtId: this.state.DistrictId,
				// tehsilId: this.state.TehsilId,
			},
			(data) => {
				this.setState({
					Riderlist: data.data,
					AllFetchedRider: data.data,
					RiderLoader: false,
				});
			},
			(error) => {
				this.setState({
					RiderLoader: false,
				});
				this.props.ShowAlert({ Type: 0, Msg: error });
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};
	ResetForm = () => {
		this.setState({
			Id: 0,
			isBatchLimit: false,
			TaskRepeatTypeVal: 1,
			SelectedRepeatDaysArr: [],
			Columns: [],
			rows: [],
			MatrixBlocks: [],
			InsertedMatrixList: [],
			IsValidated: false,
			ProvinceId: 0,
			DistrictId: 0,
			HCFTypeId: 1,
			BHUList: [],
			RHCList: [],
			BHUId: [],
			RHCId: [],
			NonClusterdRHCList: [],
			NonClusterdRHCId: 0,
			XpertSitelist: [],
			XpertSiteId: 0,
			RiderId: [],
			isDirectSubmit: false,
			LastSavedisBatchLimit: null,
			LastSavedbatchlimit: 0,
			isValidatePossibility: true,
		});
		$("#ClusterName").val("");
		$("#CutOffTime").val("");
		$("#batchlimit").val("");
		$("#everyNoOfDays").val("");
		$(".RepeatDays-Div-Selected").removeClass("RepeatDays-Div-Selected");
	};
	ValidateForm = () => {
		// e.preventDefault()

		if ($("#ClusterName").val() === "" || $("#ClusterName").val() === null) {
			this.props.ShowAlert({ Type: 0, Msg: "Please enter cluster name" });
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}
		if ($("#CutOffTime").val() === "" || $("#CutOffTime").val() === null) {
			this.props.ShowAlert({ Type: 0, Msg: "Please enter cut off time" });
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}
		if (
			(this.state.isBatchLimit && $("#batchlimit").val() === "") ||
			$("#batchlimit").val() === null
		) {
			this.props.ShowAlert({ Type: 0, Msg: "Please enter batch limit" });
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}
		if (
			(this.state.TaskRepeatTypeVal === 3 &&
				$("#everyNoOfDays").val() === "") ||
			$("#everyNoOfDays").val() === null
		) {
			this.props.ShowAlert({ Type: 0, Msg: "Please enter no of days" });
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}
		if (this.state.isBatchLimit && $("#batchlimit").val() < 1) {
			this.props.ShowAlert({
				Type: 0,
				Msg: "Please enter valid sample batch limit",
			});
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}
		if (
			this.state.TaskRepeatTypeVal === 2 &&
			this.state.SelectedRepeatDaysArr.length === 0
		) {
			this.props.ShowAlert({ Type: 0, Msg: "Please select week days" });
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}
		if (this.state.TaskRepeatTypeVal === 3 && $("#everyNoOfDays").val() < 1) {
			this.props.ShowAlert({ Type: 0, Msg: "Please enter valid no of days" });
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}
		if (this.state.ProvinceId === 0) {
			this.props.ShowAlert({ Type: 0, Msg: "Please select province" });
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}
		if (this.state.DistrictId === 0) {
			this.props.ShowAlert({ Type: 0, Msg: "Please select district" });
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}
		if (this.state.HCFTypeId === 1 && this.state.BHUId.length === 0) {
			this.props.ShowAlert({ Type: 0, Msg: "Please select atleast one BHU" });
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}
		// if (this.state.HCFTypeId === 2 && this.state.NonClusterdRHCId === 0) {
		//     this.props.ShowAlert({Type: 0, Msg: "Please select RHC"})
		//     setTimeout(function () {
		//         $("#Alertmsgbtn").click()
		//     }, 50);
		//     return
		// }
		// if (this.state.HCFTypeId === 2 && this.state.RHCId.length === 0) {
		//     this.props.ShowAlert({Type: 0, Msg: "Please select atleast one RHC"})
		//     setTimeout(function () {
		//         $("#Alertmsgbtn").click()
		//     }, 50);
		//     return
		// }
		if (this.state.HCFTypeId === 2 && this.state.XpertSiteId === 0) {
			this.props.ShowAlert({ Type: 0, Msg: "Please select Xpert Site" });
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}
		// if (this.state.RiderId.length == 0) {
		//     this.props.ShowAlert({Type: 0, Msg: "Please select atleast one rider"})
		//     setTimeout(function () {
		//         $("#Alertmsgbtn").click()
		//     }, 50);
		//     return
		// }
		this.setState(
			{
				Columns: [],
				rows: [],
				MatrixBlocks: [],
			},
			() => {
				this.CreateMatrix(() => {
					if (this.state.isDirectSubmit) {
						this.SubmitForm();
					} else {
						this.setState({
							IsValidated: true,
						});
					}
				});
			}
		);
	};
	FillModel = () => {
		// var pickupArr=this.state.ClusterTypeId==1?this.state.BHUId : this.state.RHCId
		// var sortedPickups= pickupArr.sort((a, b) => (a.id > b.id) ? 1 : -1)
		// var pickupIds= ","+ Common.convertToCommaString( sortedPickups,"id") +","

		const SubRecipient = this.state.SrList.find(
			(d) => +d.id === +this.state.SrId
		);
		console.log('this.state.BHUId->' + this.state.BHUId);
		var pickupIds =
			"," + Common.convertToCommaString(this.state.BHUId, "id") + ",";
		var riderIds =
			"," + Common.convertToCommaString(this.state.RiderId, "id") + ",";
		var rhcIds =
			"," + Common.convertToCommaString(this.state.RHCIds, "id") + ",";
		var weekDays = "";
		if (this.state.TaskRepeatTypeVal === 2) {
			var dayslist = this.state.SelectedRepeatDaysArr;
			for (var i in dayslist) {
				weekDays = weekDays === "" ? dayslist[i] : weekDays + "," + dayslist[i];
			}
		}
		var matrixList = this.state.MatrixBlocks;
		var objlist = [];
		for (var a in matrixList) {
			objlist = objlist.concat(matrixList[a].list);
		}
		return {
			id: this.state.Id,
			provinceId: this.state.ProvinceId,
			districtId: this.state.DistrictId,
			xpertSiteId:
				this.state.HCFTypeId === 2 || this.state.Subtype === 3
					? this.state.XpertSiteId
					: "",
			name: $("#ClusterName").val(),
			pickupIds: this.state.HCFTypeId === 1 ? pickupIds : rhcIds,
			riderIds: riderIds,
			isBatchLimit: this.state.isBatchLimit,
			cutOffTime: Common.ConvertToUtcDateTime(
				Common.getOnlyDate(new Date()) + " " + $("#CutOffTime").val()
			),
			deliverybatchsize: this.state.isBatchLimit ? $("#batchlimit").val() : 0,
			visitsFrequencyType: this.state.TaskRepeatTypeVal,
			weekDays: weekDays,
			everyNoOfDays:
				this.state.TaskRepeatTypeVal === 3 ? $("#everyNoOfDays").val() : 0,
			typeId: this.state.Subtype === 3 ? 2 : this.state.HCFTypeId,
			rhcId: this.state.Subtype === 1 ? this.state.RHCId : "",
			Obj: objlist,
			subtype: +this.state.Subtype,
			SubRecipient_Id: this.state.SrId,
			LastSavedisBatchLimit: this.state.LastSavedisBatchLimit,
			LastSavedbatchlimit: this.state.LastSavedbatchlimit,
			SubRecipient_CompleteName: SubRecipient?.complete_name,
			SubRecipient_ShortName: SubRecipient?.short_name,
			isValidatePossibility: this.state.isValidatePossibility,
		};
	};
	SelectRHCEdit = () => {
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.BaseUrlAPI + "/api/HCF/SelectNonClusteredRHCEdit",
			{ clusterId: this.state.Id },
			(Result) => {
				if (Result.status) {
					if (this.state.Id === 0) {
						this.setState({
							HCFLoader: false,
						});
					} else {
						this.setState({
							AllFetchedRHC: Result.data,
							HCFLoader: false,
						});
					}
				} else {
					this.setState({
						HCFLoader: false,
					});
					this.props.ShowAlert({ Type: 0, Msg: Result.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
			},
			(error) => {
				this.setState({
					HCFLoader: false,
				});
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};
	SelectBHUEdit = () => {
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.BaseUrlAPI + "/api/HCF/SelectNonClusteredEdit",
			{ clusterId: 0 },
			(Result) => {
				if (Result.status) {
					var BHUList = [];
					var RHCList = [];
					for (var i = 0; i < Result.data.length; i++) {
						if (Result.data[i].typeId === 1) {
							BHUList.push(Result.data[i]);
						} else {
							RHCList.push(Result.data[i]);
						}
					}

					//////////   to load data correctly in edit mode ///////////////
					if (this.state.Id === 0) {
						//
					} else {
						this.setState({
							HCFLoader: false,
							BHUList: BHUList,
							RHCList: RHCList,
							AllFetchedBHU: BHUList,
							AllFetchedRHC: RHCList,
						});
					}

					/////////    end here //////////////
				} else {
					this.setState({
						HCFLoader: false,
					});
					this.props.ShowAlert({ Type: 0, Msg: Result.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
			},
			(error) => {
				this.setState({
					HCFLoader: false,
				});
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};
	SubmitForm = () => {
		// e.preventDefault()
		if (this.state.isBatchLimit && $("#batchlimit").val() < 1) {
			this.props.ShowAlert({
				Type: 0,
				Msg: "Please enter valid sample batch limit",
			});
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}

		if (
			this.state.TaskRepeatTypeVal === 2 &&
			this.state.SelectedRepeatDaysArr.length === 0
		) {
			this.props.ShowAlert({ Type: 0, Msg: "Please select week days" });
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}

		if (this.state.TaskRepeatTypeVal === 3 && $("#everyNoOfDays").val() < 1) {
			this.props.ShowAlert({ Type: 0, Msg: "Please enter valid no of days" });
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}

		if (this.state.ProvinceId === 0) {
			this.props.ShowAlert({ Type: 0, Msg: "Please select province" });
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}

		if (this.state.DistrictId === 0) {
			this.props.ShowAlert({ Type: 0, Msg: "Please select district" });
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}

		if (this.state.HCFTypeId === 1 && this.state.BHUId.length === 0) {
			this.props.ShowAlert({ Type: 0, Msg: "Please select atleast one BHU" });
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}

		// if (this.state.HCFTypeId === 2 && this.state.NonClusterdRHCId === 0) {
		// 	this.props.ShowAlert({ Type: 0, Msg: "Please select RHC" });
		// 	setTimeout(function () {
		// 		$("#Alertmsgbtn").click();
		// 	}, 50);
		// 	return;
		// }

		if (this.state.HCFTypeId === 2 && this.state.RHCIds.length === 0) {
			this.props.ShowAlert({ Type: 0, Msg: "Please select atleast one RHC" });
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}

		if (this.state.HCFTypeId === 2 && this.state.XpertSiteId === 0) {
			this.props.ShowAlert({ Type: 0, Msg: "Please select Xpert Site" });
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}

		if (this.state.RiderId.length === 0) {
			this.props.ShowAlert({ Type: 0, Msg: "Please select atleast one rider" });
			setTimeout(function () {
				$("#Alertmsgbtn").click();
			}, 50);
			return;
		}

		var matrixList = this.state.MatrixBlocks;
		for (var i in matrixList) {
			if (
				matrixList[i].list[0].distance == null ||
				matrixList[i].list[0].distance === "" ||
				isNaN(matrixList[i].list[0].distance)
			) {
				this.props.ShowAlert({
					Type: 0,
					Msg: "All Distance of first column are required",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
				return;
			}
		}
		const parameters = this.FillModel();
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Post",
			false,
			this.state.Id === 0
				? Common.APILinks.Save_HCFCluster
				: Common.APILinks.Update_HCFCluster,
			JSON.stringify(parameters),
			(resp) => {
				if (resp.status) {
					this.props.ShowLoader({ Isloading: false });
					this.props.ShowAlert({ Type: 1, Msg: "Saved successfully" });
					setTimeout(() => {
						$("#Alertmsgbtn").click();
					}, 50);
					$("#Form_CancelBtn").click();
				} else {
					this.props.ShowLoader({ Isloading: false });
					if (resp.message === "job possibility") {
						this.setState(
							{
								possiblitySamplesCount: resp.samplesCount,
								possiblityassignmentCount: resp.assignmentCount,
							},
							() => {
								$("#show_AssignmentPossibilityModel").click();
							}
						);
						return;
					}
					this.props.ShowAlert({ Type: 0, Msg: resp.message });
					setTimeout(() => {
						$("#Alertmsgbtn").click();
					}, 50);
				}
			},
			(error) => {
				this.props.ShowLoader({ Isloading: false });
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again.",
				});
				setTimeout(() => {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};
	selectHCFClusterDetails = (Id) => {
		this.props.ShowLoader({ Isloading: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.APILinks.Select_HCFCluster,
			{ Id: Id },
			(resp) => {
				if (resp.status) {
					this.LoadDataInEditMode(resp.data);
				} else {
					this.props.ShowAlert({ Type: 0, Msg: resp.message });
					setTimeout(() => {
						$("#Alertmsgbtn").click();
					}, 50);
					if (resp.message === "No record found.") $("#Form_CancelBtn").click();
				}
			},
			(error) => {
				this.props.ShowLoader({ Isloading: false });
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again.",
				});
				setTimeout(() => {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};
	LoadDataInEditMode = (data) => {
		debugger;
		console.log("::::::::=========data:::::::::", data);
		const subrecpient = this.state.SrList.filter(
			(item) => item.districtid === data.districtId
		);
		var cutOffDatetime = data.cutOffTime;
		if (cutOffDatetime != null) {
			cutOffDatetime = Common.ConvertToLocalDateTime(cutOffDatetime);
			var arr = cutOffDatetime.split(" ");
			var time = Common.get24hrtime(arr[3] + " " + arr[4]);
			$("#CutOffTime").val(time);
		}
		$("#ClusterName").val(data.name);
		$("#batchlimit").val(
			data.deliverybatchsize == null || data.deliverybatchsize === 0
				? ""
				: data.deliverybatchsize
		);
		$("#everyNoOfDays").val(
			data.everyNoOfDays == null || data.everyNoOfDays === 0
				? ""
				: data.everyNoOfDays
		);

		this.setState(
			{
				ProvinceId: data.provinceId,
				DistrictId: data.districtId,
				RideType: data.obj[0]?.rideType || this.state.RideType,
				FilteredSrs: subrecpient,
				SrId: data.subRecipient_Id,
				Subtype: data.subtype,
				isBatchLimit: data.isBatchLimit,
				LastSavedisBatchLimit: data.isBatchLimit,
				LastSavedbatchlimit:
					data.deliverybatchsize == null || data.deliverybatchsize === ""
						? 0
						: data.deliverybatchsize,
				TaskRepeatTypeVal: data.visitsFrequencyType,
				HCFTypeId: data.subtype === 3 ? 1 : data.typeId,
				InsertedMatrixList: data.obj,
				RHCIdNew: data.rhcId,
				RHCId: data.rhcId,
			},
			() => {
				console.log(":::::::::::::::::::::set");
				this.SelectRiders();

				setTimeout(() => {
					this.props.ShowLoader({ Isloading: false });

					this.FilterDistrictDependant(data.districtId, () => {
						var riderIds = data.riderIds.split(",");
						riderIds.shift();
						riderIds.pop();

						var ProcessedRiders = Common.ProcessDataInArray(
							this.state.Riderlist,
							"id"
						);
						var selectedRiders = [];
						for (var i in riderIds) {
							if (ProcessedRiders[riderIds[i]] !== undefined)
								selectedRiders.push(ProcessedRiders[riderIds[i]]);
						}
						console.log("data.pickupIds==========", data.pickupIds);

						var pickupIds = data.pickupIds.split(",");
						pickupIds.shift();
						pickupIds.pop();
						var ProcessedPickup = Common.ProcessDataInArray(
							data.typeId === 1 || data.subtype === 3
								? this.state.AllFetchedBHU
								: this.state.AllFetchedRHC,
							"id"
						);
						//var ProcessedPickup = _.keyBy(data.typeId === 1 || data.subtype === 3 ? this.state.AllFetchedBHU : this.state.AllFetchedRHC, 'id')
						console.log("processed==========", ProcessedPickup);
						console.log("pickupIds==========", pickupIds);
						console.log("RHCId==========", this.state.RHCId);

						var selectedPickup = [];
						_.map(pickupIds, (id) => {
							console.log("=========id", id);
							if (ProcessedPickup[id]) {
								console.log("=========id matched", ProcessedPickup[id]);
								selectedPickup.push(ProcessedPickup[id]);
							}
							return selectedPickup;
						});

						// var selectedPickup = []
						// console.log({ pickupIds: this.state.AllFetchedRHC, ProcessedPickup })
						// for (var i in pickupIds) {
						//   if (ProcessedPickup[pickupIds[i]] !== undefined)
						//     selectedPickup.push(ProcessedPickup[pickupIds[i]])
						// }
						var repeatdaysarr = [];
						if (data.weekDays !== "" && data.weekDays != null)
							repeatdaysarr = data.weekDays.split(",");
						for (var j = 0; j < repeatdaysarr.length; j++) {
							$("#" + repeatdaysarr[j] + "-Div").addClass(
								"RepeatDays-Div-Selected"
							);
						}
						console.log("selectedPickup:::::::::::", selectedPickup);
						this.setState({
							SelectedRepeatDaysArr: repeatdaysarr,
							BHUId:
								data.typeId === 1 || data.subtype === 3 ? selectedPickup : [],
							//RHCId: selectedPickup,
							RHCIds: data.typeId === 2 ? selectedPickup : [],
							NonClusterdRHCId: data.rhcId,
							XpertSiteId: data.xpertSiteId,
							RiderId: selectedRiders,
							Subtype: data.subtype,
						});
					});
				}, 20000);
			}
		);
	};
	onDelete = () => {
		this.setState(
			{
				alertModalData: {
					title: "Delete HCF Cluster",
					message: "Are you sure you want to delete this record.",
					First_Callback: () => {
						$("#Generic-modal-CloseBtn").click();
						this.DeleteRecord();
					},
					Second_Callback: () => {
						$("#Generic-modal-CloseBtn").click();
					},
					type: 1,
				},
			},
			() => {
				$("#Show_ArletModal").click();
			}
		);
	};
	DeleteRecord = () => {
		this.props.ShowLoader({ Isloading: true });
		Common.Ajax(
			this.props.UserAuthentication.AuthToken,
			"Get",
			false,
			Common.APILinks.Delete_HCFCluster,
			{ id: this.state.Id },
			(Result) => {
				if (Result.status) {
					this.props.ShowLoader({ Isloading: false });
					this.props.ShowAlert({ Type: 1, Msg: "Deleted Successfully." });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
					$("#Form_CancelBtn").click();
				} else {
					this.props.ShowLoader({ Isloading: false });
					this.props.ShowAlert({ Type: 0, Msg: Result.message });
					setTimeout(function () {
						$("#Alertmsgbtn").click();
					}, 50);
				}
			},
			(error) => {
				this.props.ShowLoader({ Isloading: false });
				this.props.ShowAlert({
					Type: 0,
					Msg: "Something went wrong, please try again.",
				});
				setTimeout(function () {
					$("#Alertmsgbtn").click();
				}, 50);
			}
		);
	};
	// Matrix
	CreateMatrix = (call_back) => {
		var ProcessedPickups =
			this.state.HCFTypeId === 1
				? Common.ProcessDataInArray(
						this.state.Id === 0 ? this.state.BHUList : this.state.AllFetchedBHU,
						"id"
				  )
				: Common.ProcessDataInArray(
						this.state.Id === 0 ? this.state.RHCList : this.state.AllFetchedRHC,
						"id"
				  );
		var ProcessedDestinations =
			this.state.HCFTypeId === 1 && this.state.Subtype !== 3
				? Common.ProcessDataInArray(
						this.state.Id === 0 ? this.state.RHCList : this.state.AllFetchedRHC,
						"id"
				  )
				: Common.ProcessDataInArray(this.state.XpertSitelist, "id");
		var Columns = this.GetMatrixColumns(
			ProcessedPickups,
			ProcessedDestinations
		);
		var rows = this.GetMatrixRows(ProcessedPickups);
		var MatrixBlocks = [];
		var rowlist = [];
		var ProcessedOldMatrix = [];

		if (this.state.Id !== 0) {
			var prevList = this.state.InsertedMatrixList;
			for (var i in prevList) {
				var index =
					prevList[i].pickupId +
					"_" +
					prevList[i].destinationId +
					"_" +
					prevList[i].destinationType;
				ProcessedOldMatrix[index] = prevList[i];
			}
		}
		for (var i = 0; i < rows.length; i++) {
			for (var j = 0; j < Columns.length; j++) {
				var obj = {
					pickupId: rows[i].id,
					destinationId: Columns[j].id,
					distance:
						this.state.Id === 0
							? j === 0
								? ""
								: rows[i].id === Columns[j].id
								? 0
								: ""
							: this.GetBlockDistance(
									rows[i].id,
									Columns[j].id,
									ProcessedOldMatrix,
									j
							  ),
					isEdit: j === 0 ? true : rows[i].id !== Columns[j].id,
					destinationType:
						j === 0
							? this.state.HCFTypeId === 1 && this.state.Subtype !== 3
								? Common.destinationTypes.RHC
								: Common.destinationTypes.XpertSite
							: this.state.HCFTypeId === 1
							? Common.destinationTypes.BHU
							: Common.destinationTypes.RHC,
					rideType: this.state.RideType,
				};
				rowlist.push(obj);
			}
			let brickobj = {
				pickupLable: rows[i].label,
				list: rowlist,
			};
			MatrixBlocks.push(brickobj);
			rowlist = [];
		}
		this.setState(
			{
				Columns,
				rows,
				MatrixBlocks,
			},
			() => {
				call_back();
			}
		);
	};
	GetMatrixColumns = (ProcessedPickups, ProcessedDestinations) => {
		var list = [];
		var Pickuplist =
			this.state.HCFTypeId === 1 ? this.state.BHUId : this.state.RHCIds;
		let obj = {
			id:
				this.state.HCFTypeId === 1 && this.state.Subtype !== 3
					? this.state.RHCId
					: this.state.XpertSiteId,
			type:
				(this.state.HCFTypeId === 2 && this.state.Subtype === 2) ||
				(this.state.HCFTypeId === 2 && this.state.Subtype === 3)
					? "Xpert Site"
					: "RHC",
			label:
				ProcessedDestinations[
					this.state.HCFTypeId === 1 && this.state.Subtype !== 3
						? this.state.RHCId
						: this.state.XpertSiteId
				]?.name,
		};
		list.push(obj);
		for (var i in Pickuplist) {
			let obj = {
				id: Pickuplist[i].id,
				type: this.state.HCFTypeId === 1 ? "BHU/GP" : "RHC/PPM",
				label: ProcessedPickups[Pickuplist[i].id]?.name,
			};
			list.push(obj);
		}
		return list;
	};
	GetMatrixRows = (ProcessedPickups) => {
		var list = [];
		var Pickuplist =
			this.state.HCFTypeId === 1 ? this.state.BHUId : this.state.RHCIds;
		for (var i in Pickuplist) {
			let obj = {
				id: Pickuplist[i].id,
				label: ProcessedPickups[Pickuplist[i].id]?.name,
			};
			list.push(obj);
		}
		return list;
	};
	handleDistancechange = (rowIndex, blockIndex) => {
		var temarr = this.state.MatrixBlocks;
		temarr[rowIndex].list[blockIndex].distance = parseInt(
			$("#" + rowIndex + "_" + blockIndex + "_MatrixInput").val()
		);
		temarr[rowIndex].list[blockIndex].verifiedDistance = parseInt(
			$("#" + rowIndex + "_" + blockIndex + "_MatrixInputVerified").val()
		);
		this.setState({
			MatrixBlocks: temarr,
		});
	};
	// handleRiderTypechange = (rowIndex, blockIndex) => {
	//     var temarr = this.state.MatrixBlocks
	//     temarr[rowIndex].list[blockIndex].rideType = $("#" + rowIndex + "_" + blockIndex + "_type").val()
	//     this.setState({
	//         MatrixBlocks: temarr
	//     })
	// }
	GetBlockDistance = (pickupId, destinationId, ProcessedOldMatrix, jindex) => {
		var index =
			pickupId +
			"_" +
			destinationId +
			"_" +
			(jindex === 0
				? this.state.HCFTypeId === 1 && this.state.Subtype !== 3
					? Common.destinationTypes.RHC
					: Common.destinationTypes.XpertSite
				: this.state.HCFTypeId === 1
				? Common.destinationTypes.BHU
				: Common.destinationTypes.RHC);
		if (ProcessedOldMatrix[index] === undefined) {
			return jindex === 0 ? "" : pickupId === destinationId ? 0 : "";
		} else {
			return ProcessedOldMatrix[index].distance;
		}
	};
	// GetBlockRideType = (pickupId, destinationId, ProcessedOldMatrix, jindex) => {
	//     var index = pickupId + "_" + destinationId + "_" + (jindex === 0 ? (this.state.HCFTypeId === 1 ? Common.destinationTypes.RHC : Common.destinationTypes.XpertSite) : (this.state.ClusterTypeId === 1 ? Common.destinationTypes.BHU : Common.destinationTypes.RHC))
	//     if (ProcessedOldMatrix[index] === undefined) {
	//         return jindex === 0 ? "" : pickupId === destinationId ? 0 : ""
	//     } else {
	//         return ProcessedOldMatrix[index].rideType
	//     }
	// }
}

export default connect(mapStateToProps, mapDispatchToProps)(HCFCluster_Add);
